<template>
  <div v-if="isChatAvailable">
    <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessages="newMessages"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      @onType="handleOnType"
      @edit="editMessage"
      @addParticipant="addParticipant($event)"
      @removeParticipant="removeParticipant($event)" />
  </div>
</template>
<script>
import CloseIcon from './assets/close-icon.png'
import OpenIcon from './assets/logo-no-bg.svg'
import FileIcon from './assets/file.svg'
import CloseIconSvg from './assets/close.svg'
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  name: 'app',
  data() {
    return {
      icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessages: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    }
  },
  computed: {
    ...mapState([
      'userId',
      'dashOwner'
    ]),
    isOwner() {
      return this.dashOwner === this.userId;
    },
    isChatAvailable() {
      return this.isOwner || !!this.participants.find(p => window.fbUser && window.fbUser.email === p.email)
    }
  },
  async mounted() {
    await this.loadParticipants();

    if (!this.isChatAvailable) {
      return ;
    }

    let inited = false;

    db.chat.messages.getRef().limitToLast(1).on('child_added', async (snapshot) => {
      if (!inited) {
        inited = true;
        this.updateNewMessages();
        return;
      }

      const message = snapshot.val();
      message.id = snapshot.key;
      if (window.fbUser.email !== message.author) {
        if (this.isChatOpen) {
          this.messageList = [ ...this.messageList, message ];
          this.updateLastReadTime();
        } else {
          this.newMessages++;
        }
      }     
    })
  },
  methods: {
    async updateNewMessages() {
      const { lastRead } = await db.chat.lastRead.get(this.userId) || {};
      db.chat.messages.getAll((messages) => {
        this.newMessages = messages.reduce((count, message) => {
          if(window.fbUser && message.author !== window.fbUser.email) {
              if (!lastRead || lastRead < message.date) {
                count++;
              }
          }

          return count;
        }, 0);
      });
    },
    async updateLastReadTime() {
      await db.chat.lastRead.save(this.userId, {lastRead: Date.now()});
    },
    loadMessages() {
      db.chat.messages.getAll((messages) => {
        this.messageList = messages.sort((a, b) => a.date - b.date)
      });
    },
    async loadParticipants() {
      return db.chat.participants.getAll(participants => this.participants = participants);
    },
    onMessageWasSent (message) {
      message = {...message, ...this.createEmptyMessageModel()};
      db.chat.messages.add(message).then((res) => {});
      this.messageList = [ ...this.messageList, message ]
    },
    openChat () {
      this.isChatOpen = true;
      this.newMessages = 0;
      this.loadMessages();
      this.updateLastReadTime();
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
  	},
    handleOnType () {
      // console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
    createEmptyMessageModel() {
      return {
        date: Date.now(),
        user: this.userId,
        author: window.fbUser.email
      };
    },
    addParticipant(participant) {
      const isExist = participant.email === window.fbUser.email || this.participants.find(p => p.email === participant.email);
      if (!isExist) {
        db.chat.participants.add(participant).then(res => participant.id = res.key);
        this.participants = [...this.participants, participant];
      }
    },
    removeParticipant(participant) {
      db.chat.participants.delete(participant.id).then((res) => {});
      this.participants = this.participants.filter(p => p.uid !== participant.uid);
    }
  }
}
</script>
<style scoped>
</style>
